import { lazy } from 'react'

const TeamPage = lazy(() => import('./TeamPage'))

export { TeamPage }
